import React from "react";
import { useTranslation } from "react-i18next";

const cards = [
  {
    image: "/assets/images/moments/moment_1.jpg",
    labelKey: "home.experience.cards.prelude",
  },
  {
    image: "/assets/images/moments/moment_2.jpg",
    labelKey: "home.experience.cards.celebration",
  },
  {
    image: "/assets/images/moments/moment_3.jpg",
    labelKey: "home.experience.cards.legacy",
  },
];

const ExperienceCollectionCards = () => {
  const { t } = useTranslation();
  return (
    <div className="home-col-wrapper _70-bottom w-dyn-list">
      <div role="list" className="home-col-list w-dyn-items">
        {cards.map((card, index) => (
          <div key={index} role="listitem" className="home-col-item w-dyn-item">
            <div className="card-link w-inline-block">
              <div className="col-im-link">
                <div
                  style={{ backgroundImage: `url('${card.image}')` }}
                  className="card-im"
                ></div>
              </div>
              <div className="card-txt-link">
                <div>{t(card.labelKey)}</div>
                <div className="ball"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExperienceCollectionCards;
